import { api } from './api'

/**
 * The learner's team (V4). `teams_mine` — bearer. Answers
 * `{ enabled, periodKey, periodEndsAt, team }`; `team` is
 * `{ id, name, nameEn, level, members: [{ id, displayName, avatar, level, streakDays, me }] }`
 * or null — always null while AppSetting `teams.enabled` is off, and also
 * before onboarding or for a learner the monthly build left out as inactive.
 * A teammate carries only what the feed already shows of an author.
 */
export async function myTeam() {
  const { data } = await api.get('/teams/mine')
  return data
}

/**
 * The teammates' day (V5 `teams_activity`) — bearer. Answers
 * `{ enabled, periodKey, day, presenceMinutes, items }`, `items[]` =
 * `{ member (teams_mine's fields + photoUrl), xpToday, practicingNow }`,
 * practising first. Empty while AppSetting `teams.enabled` is off or
 * without a seat; the home box hides then.
 */
export async function teamActivity() {
  const { data } = await api.get('/teams/activity')
  return data
}
